export const useDevTools = researchGoFetch => {
  global.researchGoDevTools = {
    researchGoFetch: (url, options) =>
      researchGoFetch(url, options)
        .then(x => x.json())
        .then(console.log)
  };
};
